











































import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { required, email } from 'vuelidate/lib/validators';
import { routeTo } from '@/api/reactor/reactions';

@Component({
  validations: {
    form: {
      email: {
          required,
          email
      },
    },
  },
  reactions: {
    '$auth/resetRequested': routeTo('resetPassword')
  }
})
export default class Forgot extends Vue {
  working: boolean = false;
  form: any = {
    email: '',
  };
  errorSnack: boolean = false;
  snackMessage: string = "";

  get nameErrors () {
    const errors: any[] = [];
    if (this.$v && this.$v.form && this.$v.form.email) {
      if (!this.$v.form.email.$dirty) return errors;
      !this.$v.form.email.required && errors.push('Email is required.');
      !this.$v.form.email.email && errors.push('Need a valid email.');
    }
    return errors
  }

  async requestCode() {
      try {
        await this.$store.dispatch('$auth/forgotPassword', this.form);
      } catch (e) {
        console.log('forgot exception', e);
        this.snackMessage = "Email not found.";
        this.errorSnack = true;
      }
  }
}
